import { render } from "./News-form.vue?vue&type=template&id=676500db&scoped=true"
import script from "./News-form.vue?vue&type=script&lang=js"
export * from "./News-form.vue?vue&type=script&lang=js"

import "./News-form.vue?vue&type=style&index=0&id=676500db&scoped=true&lang=css"

import exportComponent from "/Users/thomas/Desktop/CNT/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676500db"]])

export default __exports__